import { Component, OnInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductDetailsMainSlider, ProductDetailsThumbSlider } from '../../shared/data/slider';
import { AuthService } from '../../shared/services/auth.service';
import { RestaurantService } from '../../shared/services/restaurant.service';
import { CartService } from '../../shared/services/cart-service';
import { CustomModalComponent } from '../../shared/components/modal/custom-modal/custom-modal.component';
//import { SizeModalComponent } from "../../../shared/components/modal/size-modal/size-modal.component";
import { DB, RESPONSE, AppInfo, EitUrl } from '../../shared/services/env.service';
import { TypeOrder, ET_RestaurantServiceTypeEnabled, TypeService } from '../../shared/services/config-app';
import { EitCart } from '../../shared/classes/eitcart';
import { EitPlace } from '../../shared/classes/eitplace';
import { ReviewBoxComponent } from '../../shared/components/restaurant/review-box/review-box.component';
import { InfoPromoBoxComponent } from '../../shared/components/restaurant/info-promo-box/info-promo-box.component';
import { InfoBoxComponent } from '../../shared/components/restaurant/info-box/info-box.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationSelectComponent } from '../../shared/components/modal/location-select/location-select.component';
import { AllergensComponent } from '../../shared/components/modal/allergens/allergens.component';
import { AppService } from '../../shared/services/app.service';
import { ApiService } from '../../shared/services/api.service';
import { DatetimeModalComponent } from '../../shared/components/modal/datetime-modal/datetime-modal.component';

@Component({
  selector: 'app-restaurant-view',
  templateUrl: './restaurant-view.component.html',
  styleUrls: ['./restaurant-view.component.scss']
})
export class RestaurantViewComponent implements OnInit {

  public record: any = {};
  public restaurant: any = {};
  public restFull: any = {};
  public location: any = {};
  public counter: number = 1;
  public activeSlide: any = 0;
  public selectedSize: any;
  public gallery = [];
  public promozioni = [];
  related: Array<any> = [];
  list: any;
  public themeLogo: string = ''; // Change Logo
  //cartData: any = "";
  typeOrder: any = "";
  service: any = "1";
  typeService: any = "";
  public isCollapsedMenu = false;
  public isCollapsedReview = true;
  public isCollapsedPromo = true;
  public isCollapsedInfo = true;
  sticky: boolean = true;
  public stick: boolean = false;
  order_date: string = ""
  public cartData: any = {};

  isLogged: boolean = false;
  user: any = {};  
  headerImg: string = ""

  searchbar: any = {query: "", placeholder: "Piatti"}
  search: string = '';
  
  appInfo: any = AppInfo
  distance = 50;
  scrollSpeed = 100;
  leftArrowHide = false;
  rightArrowHide = false;
  loaderMenu = true;

  @ViewChild("customModal") CustomModal: CustomModalComponent;
  @ViewChild("collapseReview") collapseReview: ReviewBoxComponent;
  @ViewChild("collapsePromo") collapsePromo: InfoPromoBoxComponent;
  @ViewChild("collapseInfo") collapseInfo: InfoBoxComponent;
  @ViewChild('mixScroll', { static: false }) scrollWrapper: ElementRef;
  //@ViewChild("sizeChart") SizeChart: SizeModalComponent;

  public ProductDetailsMainSliderConfig: any = ProductDetailsMainSlider;
  public ProductDetailsThumbConfig: any = ProductDetailsThumbSlider;

  constructor(private route: ActivatedRoute, private appService: AppService, private api: ApiService,
    public auth: AuthService, public restService: RestaurantService, private router: Router,
    private modalService: NgbModal, public cartService: CartService) {
    this.route.data.subscribe(response => this.record = response.data);

    this.typeOrder = TypeOrder;
    this.typeService = ET_RestaurantServiceTypeEnabled;
    //this.cartData = new EitCart();
    this.location = new EitPlace();
    this.restFull = null;  
    this.leftArrowHide = false;
    this.rightArrowHide = false;  

    this.appService.appObs.subscribe(x => {  
      this.themeLogo = this.appService.getLogo(x);
    });

    let serv = localStorage.getItem("service");
    if(serv) this.service = parseInt(JSON.parse(serv));

    /* this.isLogged = this.auth.isEITEnabled();
    if(this.isLogged){
      this.getUserInfo()
    } */

    this.isLogged = this.auth.isEITEnabled();
    
    if (this.isLogged) {        
      // authorised 
      this.getUserInfo()
    }
    else{      
      this.route.queryParams.subscribe(params => {
        if (params && params.token){
          var data: any = {externaltoken: params.token};
          //data.externaltoken = params.token;
          this.api.postj("user/security/logingulliver", data, "").subscribe(res => {
            if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK ) {
              this.auth.next(res[RESPONSE.JP_RESULT]);
              this.getUserInfo();
              this.isLogged = true;
            }
          });
        }
      });
    }

    console.log("in constr rest-delivery");
    
    var loc = JSON.parse(localStorage.getItem(DB.LOCATION));

    if (loc) {
      this.location = loc;
    } else {
      //popup
    }

    if (this.restaurant && this.restaurant.media_header) {
      this.gallery.push(AppInfo.ASSETS_URL + this.restaurant.media_header.filename);
      this.headerImg = AppInfo.ASSETS_URL + this.restFull.media_header.filename
    }
    if (this.restFull && this.restFull.mediaheader) {
      this.gallery.push(AppInfo.ASSETS_URL + this.restFull.mediaheader.filename);
      this.headerImg = AppInfo.ASSETS_URL + this.restFull.mediaheader.filename
    }

    this.restService.restaurant.subscribe(x => {
      if (x) {
        this.restFull = x;
        this.restaurant = x;
        this.promozioni = [];
        if (this.restFull && this.restFull.promozioni) {
          for (var p = 0; p < this.restFull.promozioni.length; p++) {
            if (this.restFull.promozioni[p].status == 1 && this.restFull.promozioni[p].validity_type != 1){
              this.promozioni.push(this.restFull.promozioni[p]);
            }
          }
        }
        if (this.restaurant && this.restaurant.media_header) {
          this.gallery.push(AppInfo.ASSETS_URL + this.restaurant.media_header.filename);
          this.headerImg = AppInfo.ASSETS_URL + this.restFull.media_header.filename
        }

        if (this.restFull && this.restFull.media_header && (!this.restaurant || !this.restaurant.media_header)) {
          this.gallery.push(AppInfo.ASSETS_URL + this.restFull.media_header.filename);
          this.headerImg = AppInfo.ASSETS_URL + this.restFull.media_header.filename
        }
        if (this.restFull && this.restFull.mediaheader && (!this.restaurant || !this.restaurant.mediaheader)) {
          this.gallery.push(AppInfo.ASSETS_URL + this.restFull.mediaheader.filename);
          this.headerImg = AppInfo.ASSETS_URL + this.restFull.mediaheader.filename
        }
      }
    });

    this.restService.list.subscribe(x => {
      if(x){
        this.restaurant = JSON.parse(localStorage.getItem(DB.ACTIVITY_BASE));
        
        if(this.restaurant && this.restaurant.menu && x.id === this.restaurant.menu.id) {
          this.list = x;
          this.loaderMenu = false;
        }
        else this.loaderMenu = true;
      
        // if (this.restaurant) {
        //   var ispreorder = (!this.restaurant.message_event && this.restaurant.nowclosed && !this.restaurant.day_closed && this.restaurant.preorder);
        //   // this.cartService.createCart(this.restaurant.id, this.auth.idOrder, this.location, this.service, ispreorder)
        // }
      }

    });

    this.restService.related.subscribe(x => {
      this.related = x;
    });


    this.order_date = "";
    this.cartData = new EitCart();
    this.cartService.cartObs.subscribe(x => {
      this.cartData = x;
      if(this.cartData){
        this.order_date = this.cartData.order.order_date;
        if(this.order_date == '2') this.order_date = ""
      }
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      if (this.scrollWrapper && this.scrollWrapper.nativeElement && this.scrollWrapper.nativeElement.parentElement && (this.scrollWrapper.nativeElement.scrollWidth > this.scrollWrapper.nativeElement.parentElement.clientWidth)) {
        this.leftArrowHide = true;
        this.rightArrowHide = true;
      }
    }, 1000);
  }

  // @HostListener Decorator
  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (number >= 1000 && window.innerWidth > 400) {
      this.stick = true;
    } else {
      this.stick = false;
    }
  }

  getUserInfo(){    
    this.api.postj_T("user/settings/infoaccount", "").subscribe(res => {
      console.log(res);
      if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
        setTimeout(() => {
          this.user = res[RESPONSE.JP_RESULT];
        }, 1000)
      }
    }, (err) => {
      console.log(err);
    })
  }

  changeService(val: number){
    //this.service = val
    localStorage.setItem("service", ""+this.service);
    this.cartData.order.type_order = this.service == 0 ? TypeOrder.REST_DOMICILIO : TypeOrder.REST_ASPORTO;
    //this.cartService.postCart(this.cartData)
    if (this.restaurant) {
      var ispreorder = (!this.restaurant.message_event && this.restaurant.nowclosed && !this.restaurant.day_closed && this.restaurant.preorder);
      this.cartService.createCart(this.restaurant.id, this.auth.idOrder, this.location, this.service, ispreorder)
    }
/*
    if(this.service == TypeOrder.EIT_DOMICILIO){
      this.locService.loadDelivery_R(this.location);
      this.locService.rest_delivery.subscribe(x => {
        if (x) {
          this.records = x;
          if (this.records) {
            this.updateCategory();
            this.updatePayments();
            this.updateFilter();
            this.fillPromos()
          }
        }
      });
    }
    else{      
      this.locService.loadTakeAway_R(this.location);
      this.locService.rest_ta.subscribe(x => {
        if (x) {
          this.records = x;
          if(this.records)
          {
            this.updateCategory();
            this.updatePayments();
            this.updateFilter();
            this.fillPromos()
          }
        }
      });
    }*/
  }
  selectPage(indexPage) {
    switch (indexPage) {
      case 0:
        {
          this.isCollapsedMenu = false;
          this.isCollapsedPromo = true;
          this.isCollapsedReview = true;
          this.isCollapsedInfo = true;
          this.collapseReview.canScroll = false;
          this.collapsePromo.canScroll = false;
        }
        break;

      case 1:
        {
          this.isCollapsedMenu = true;
          this.isCollapsedPromo = true;
          this.isCollapsedReview = false;
          this.isCollapsedInfo = true;
          this.collapseReview.init()
          this.collapseReview.canScroll = true;
          this.collapsePromo.canScroll = false;
        }
        break;

      case 2:
        {
          this.isCollapsedMenu = true;
          this.isCollapsedPromo = true;
          this.isCollapsedReview = true;
          this.isCollapsedInfo = false;
          this.collapseInfo.init()
          this.collapseReview.canScroll = false;
          this.collapsePromo.canScroll = false;
        }
        break;

      case 3:
        {
          this.isCollapsedMenu = true;
          this.isCollapsedPromo = false;
          this.isCollapsedReview = true;
          this.isCollapsedInfo = true;
          this.collapsePromo.init()
          this.collapseReview.canScroll = false;
          this.collapsePromo.canScroll = true;
        }
        break;
    }

  }

  ingredients(item) {
    var result = "";

    for (var iG = 0; iG < item.ingredients.length; iG++) {
      result += item.ingredients[iG].name;
      if (iG < item.ingredients.length - 1) {
        result += ", ";
      }
    }

    return result;
  };

  shortDescr(item) {
    var result = "";

    if (item.descr.length > 0 && item.descr.length < 15) {
      result = " (" + item.descr + ")";
    }

    return result;
  }

  longDescr(item) {
    var result = "";

    if (item.descr.length > 15) {
      result = item.descr + " ";
    }

    return result;
  }

  editLocation() {
    let modal = this.modalService.open(LocationSelectComponent,  { size: 'md', centered: true, ariaLabelledBy: 'Location-Modal',  backdrop: 'static'})
    modal.componentInstance.cartData = this.cartData
    modal.componentInstance.init()
    modal.componentInstance.onDismiss.subscribe((event: any) => {
      if(event.status == RESPONSE.JPS_OK){
        console.log("dismiss location response OK");
        let loc = JSON.parse(localStorage.getItem(DB.LOCATION));
        if (loc) {
          this.location = loc;
        } 
        localStorage.setItem("service", ""+event.service);
        this.service = event.service
        this.cartData.order.type_order = this.service == 0 ? TypeOrder.REST_DOMICILIO : TypeOrder.REST_ASPORTO;
        //this.api.postj_T("cart/postcart", this.cartData, "").subscribe(res => {
        this.cartService.updateCart(this.cartData, loc, this.service == 0 ? TypeService.HOME : TypeService.TAKEAWAY, event.orario, event.giornoconsegna).then(() =>{
          this.cartService.loadCart(this.cartData.order.id);
        })
/* 
          if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
            this.cartData.order.order_date = this.order_date = event.orario;
            this.cartService.postOrario(this.cartData, event.orario, event.giornoconsegna);
            //se ha modificato correttamente, leggo il nuovo indirizzo
            this.cartService.loadCart(this.cartData.order.id);
          } */
        //})
      }
    })
  }

  changeDatetime() {
    console.log(window.location.href)
    if(!this.isLogged) this.goToLogin()
    else if(this.cartData) {
      console.log("change datetime");
      //this.cartService.editLocationNoCheck(this.cartData);      
      let modal = this.modalService.open(DatetimeModalComponent, { size: 'md', centered: true, ariaLabelledBy: 'Datetime-Modal', windowClass: 'datetime-modal' })
      modal.componentInstance.order = this.cartData.order
      modal.componentInstance.init()
      modal.componentInstance.onDismiss.subscribe((event: any) => {
        if (event.status == RESPONSE.JPS_OK) {
          console.log("dismiss datetime response OK");          
          this.cartData.order.order_date = this.order_date = event.orario;
          this.cartService.postOrario(this.cartData, event.orario, event.giornoconsegna);
          //se ha modificato correttamente, leggo il nuovo indirizzo
          // this.cartService.loadCart(this.cartData.order.id);
        }
      })
    }
  }

  goToLogin(){
    // this.router.navigate(['login'], {queryParams: {returnUrl:"/restaurant/list/"}});
    let url = EitUrl.apiLoginGulliver + window.location.href;
    window.open(url,"_self"/*, "_blank"*/);    
  }

  openAllegerni() {
    let modal = this.modalService.open(AllergensComponent,  { size: 'md', centered: true, ariaLabelledBy: 'Allergens-Modal',  backdrop: 'static'})
    modal.componentInstance.allergens = this.restFull.allergens
    modal.componentInstance.link_allergens = this.restFull.menu.link_allergens
  }
  
  updateSearch(event: any){
    this.search = event;
  }

  goToRestaurant(rec: any){
    localStorage.setItem(DB.ACTIVITY_BASE, JSON.stringify(rec));
    this.list = []
    this.loaderMenu = true
  }

  scrollRight(): void {
    const listWrapper = document.getElementById('mix-items');
    const scrollLeft = listWrapper.scrollLeft;
    const distance = scrollLeft + this.distance;
    this.scroll(distance);
  }

  scrollLeft(): void {
    const leftArrow = document.getElementById('mix-items');
    const scrollLeft = leftArrow.scrollLeft;
    const distance = scrollLeft - this.distance;
    this.scroll(distance);

  }

  scroll(distance): void {
    const listWrapper = document.getElementById('mix-items');
    listWrapper.scrollTo({ behavior: 'smooth', left: distance });
  }
}
